exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled[data-v-2ad06a24]  .el-upload--picture-card {\n  display: none;\n}\n.disabled[data-v-2ad06a24]  .el-upload__tip {\n  margin-top: -10px;\n}\n.form-tip[data-v-2ad06a24] {\n  font-size: 12px;\n  color: red;\n  line-height: 1.5;\n  margin-left: 10px;\n}", ""]);

// exports
